import { RID } from '@sharefiledev/sfplugin-resource-id';
import { ResourceTypeLiteral } from '../constants';

export const getRidWithoutFileVersion = (
	rid: string | null | undefined
): string | null => {
	if (!rid) {
		return null;
	}

	const parsedRID = RID.parse(rid);
	if (rid.includes(ResourceTypeLiteral.FileVersion)) {
		return parsedRID.parent()?.toString() || null;
	}
	return rid;
};

export const getRidsWithoutFileVersion = (rids: string[]): string[] => {
	const baseRids = rids.map(x => getRidWithoutFileVersion(x) ?? '');
	return baseRids.filter(x => x !== '');
};
